function initiate_countdown(div_id, end_time, launch_url) {

  if (end_time != '') { 
    var countDownDate = new Date(end_time).getTime();

    var i = 0;

    // Run myfunc every second
    var myfunc = setInterval(function() {

      var now = new Date().getTime();
      var timeleft = countDownDate - now;
          
      // Calculating the days, hours, minutes and seconds left
      var days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
      var hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((timeleft % (1000 * 60)) / 1000);

      if (!jQuery('#' + div_id).hasClass('active')) { 
        // Set this as active.
        jQuery('#' + div_id).addClass('active');
      }
          
      // Result is output to the specific element
      jQuery('#' + div_id).find('.tblock-days').html(days);
      jQuery('#' + div_id).find('.tblock-hours').html(hours);
      jQuery('#' + div_id).find('.tblock-minutes').html(minutes);
      jQuery('#' + div_id).find('.tblock-seconds').html(seconds);

      // if days is zero just hide it.
      if (days == 0) { 
        jQuery('#' + div_id).find('.days').css('display', 'none');
      }
          
      // Display the message when countdown is over
      if (timeleft < 0) {
          clearInterval(myfunc);
          jQuery('#' + div_id).find('.tblock-days').html('0');
          jQuery('#' + div_id).find('.tblock-hours').html('0');
          jQuery('#' + div_id).find('.tblock-minutes').html('0');
          jQuery('#' + div_id).find('.tblock-seconds').html('0');
        
        if (launch_url != '' && i > 0) { 
          window.location.href = launch_url;
        }
      }

      i++;

    }, 1000);
  }
}